import { useState } from "react"
import { enqueueSnackbar } from "notistack"
import { saveFeedbackResponse } from "../../../services/generic-services/feedback"
import {
  FeedbackPrompt,
  SaveFeedbackPrompt
} from "../../../types/gqlTypes/graphql"
import { FeedbackForm } from "../components/FeedbackTray/FeedbackTrayForm"
import { User } from "../../mp-database"
import { ExperienceRatingWeights } from "../../mp-shared-components/generic-shared-components/components"

type FeedbackSubmitAdditionalProperties = {
  successfulAction?: () => void
  failedAction?: () => void
}

export const useFeedbackTraySubmit = (
  user: User,
  feedbackPrompt: FeedbackPrompt,
  additionalProperties?: FeedbackSubmitAdditionalProperties
) => {
  const { successfulAction, failedAction } = additionalProperties || {}

  const [submitLoading, setSubmitLoading] = useState<boolean>(false)

  const onSubmit = async (data: FeedbackForm) => {
    const { comment, experienceRate, allowToContact, email } = data

    if (!feedbackPrompt?.responseId) {
      console.warn("[Feedback Tray Submission]: responseId is undefined")
      return
    }

    const feedbackResponseData: SaveFeedbackPrompt = {
      followUp: allowToContact === "yes",
      followUpEmail: email || user?.email || "",
      promptResponse: String(ExperienceRatingWeights[experienceRate]) || "",
      responseId: feedbackPrompt.responseId,
      textResponse: comment || ""
    }

    try {
      setSubmitLoading(true)

      await saveFeedbackResponse(feedbackResponseData)

      enqueueSnackbar("Submission successful. Thank you for your feedback.", {
        variant: "success"
      })

      successfulAction?.()
    } catch (error) {
      console.warn("[Feedback Tray Submission]: api call error - ", error)

      failedAction?.()
    } finally {
      setSubmitLoading(false)
    }
  }
  return { submitLoading, onSubmit }
}
